module.exports = __webpack_public_path__ + "img/khqr.58ac395f.png";